<template>
    <div class="service-section pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 pb-30">
                    <div class="forum-details desk-pad-right-40">
                        <img v-lazy="$ossImg('blogs/blog-details-1-0.jpg')" alt="project">
                        <h2>{{ caseCopy.title }}</h2>
                        <p>{{ caseCopy.subtitle }}</p>
                        <p>{{ caseCopy.intro }}</p>
                        
                        <div v-for="section in caseCopy.sections || []" :key="section.title">
                            <h3>{{ section.title }}</h3>
                            <p>{{ section.body }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 pb-30">
                    <div class="sidebar-item">
                        <h3>{{ $t('news.section.title') }}</h3>
                        <div class="sidebar-recent-post">
                            <div
                                class="sidebar-recent-post-item"
                                v-for="post in sidebarNews"
                                :key="post.id"
                            >
                                <router-link :to="post.route">
                                    <img v-lazy="recentImage(post.image)" alt="project">
                                    <div class="recent-post-details">
                                        <h3>{{ post.title }}</h3>
                                        <ul class="post-entry">
                                            <li>{{ post.date }}</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-item sidebar-bg">
                        <h3>{{ $t('news.section.subtitle') }}</h3>
                        <ul class="sidebar-category">
                            <li v-for="category in sidebarCategories" :key="category.key">
                                <router-link to="/news">
                                    {{ categoryLabel(category.key) }}
                                    <span>({{ category.count }})</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SingleCasesStudyOne',
    computed: {
        caseCopy() {
            const data = this.$t('cases.singleOne')
            return typeof data === 'object' ? data : { sections: [] }
        },
        sidebarNews() {
            const cards = this.$t('news.cards')
            return Array.isArray(cards) ? cards.slice(0, 3) : []
        },
        sidebarCategories() {
            return [
                { key: 'event', count: '01' },
                { key: 'technology', count: '00' },
                { key: 'product', count: '00' },
                { key: 'company', count: '02' }
            ]
        }
    },
    methods: {
        recentImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        },
        categoryLabel(key) {
            return this.$t(`news.categories.${key}`) || key
        }
    }
}
</script>

<style scoped>
.forum-details ul {
    list-style: none;
    display: block;
    padding-left: 0;
    margin-bottom: 0;
}

.forum-details ul li {
    position: relative;
    padding-left: 20px;
    width: 100%;
    margin: 0;
    color: #767676;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
}

.forum-details ul li::before {
    content: "•";
    position: absolute;
    left: 0;
    top: -7px;
    color: #666;
    font-size: 20px;
    line-height: 1.8;
}
</style>
